/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { InboundContext } from '../context/InboundContext';
import { ContentContainer, ImageContainer } from '../components/home';
import styles from '../styles/home.module.css';

export default function Home() {
  const { inboundData } = useContext(InboundContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (!inboundData) {
      navigate('/dashboard/login');
    }
  }, [inboundData]);

  return (
    <div className={styles.homeContainer}>
      {inboundData && (
        <ImageContainer
          imageFill={inboundData?.landingPage?.imageFill}
          highlightImage={inboundData?.landingPage?.images?.highlight}
        />
      )}
      <ContentContainer
        logoImage={inboundData?.landingPage?.images?.logo}
        headline={inboundData?.landingPage?.headlineTxt}
        description={inboundData?.landingPage?.brandDesc}
        ctaButtonText={inboundData?.landingPage?.ctaBtnTxt}
        colors={inboundData?.landingPage?.colors}
        fontStyle={inboundData?.landingPage?.fontStyle}
      />
    </div>
  );
}
